export const PhysicalAddress = (props: any) => {
  const { address, city, state, latitude, longitude, pin_code } = props;
  return (
    <div className="col-sm-6 px-4">
      <table className="table table-striped border-0 mt-4">
        <tbody>
          <tr>
            <th scope="row">Address:</th>
            <td>{address}</td>
          </tr>
          <tr>
            <th scope="row">City:</th>
            <td>{city}</td>
          </tr>
          <tr>
            <th scope="row">State:</th>
            <td>{state}</td>
          </tr>
          <tr>
            <th scope="row">Latitude:</th>
            <td>{latitude}</td>
          </tr>
          <tr>
            <th scope="row">Longitude:</th>
            <td>{longitude}</td>
          </tr>
          <tr>
            <th scope="row">Pin Code:</th>
            <td>{pin_code}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
